// Recovered compiled webpack factory 52619. Edit this function expression; run npm run build.
(e, t, n) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var n in t) Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    })(t, {
      default: function () {
        return h;
      },
      useLinkStatus: function () {
        return _;
      },
    }));
  let r = n(49417),
    u = n(95155),
    o = r._(n(12115)),
    l = n(47670),
    f = n(46752),
    a = n(83011),
    c = n(62296),
    i = n(96058);
  n(94781);
  let s = n(63499),
    d = n(58607),
    p = n(11807);
  n(17045);
  let y = n(66048);
  function b(e) {
    return "string" == typeof e ? e : (0, l.formatUrl)(e);
  }
  function h(e) {
    var t;
    let n,
      r,
      l,
      [h, _] = (0, o.useOptimistic)(s.IDLE_LINK_STATUS),
      v = (0, o.useRef)(null),
      {
        href: j,
        as: P,
        children: T,
        prefetch: C = null,
        passHref: M,
        replace: k,
        shallow: I,
        scroll: m,
        onClick: E,
        onMouseEnter: O,
        onTouchStart: S,
        legacyBehavior: w = !1,
        onNavigate: x,
        ref: D,
        unstable_dynamicOnHover: L,
        ...R
      } = e;
    ((n = T),
      w &&
        ("string" == typeof n || "number" == typeof n) &&
        (n = (0, u.jsx)("a", { children: n })));
    let A = o.default.useContext(f.AppRouterContext),
      N = !1 !== C,
      K =
        !1 !== C
          ? null === (t = C) || "auto" === t
            ? y.FetchStrategy.PPR
            : y.FetchStrategy.Full
          : y.FetchStrategy.PPR,
      { href: U, as: F } = o.default.useMemo(() => {
        let e = b(j);
        return { href: e, as: P ? b(P) : e };
      }, [j, P]);
    w && (r = o.default.Children.only(n));
    let B = w ? r && "object" == typeof r && r.ref : D,
      q = o.default.useCallback(
        (e) => (
          null !== A && (v.current = (0, s.mountLinkInstance)(e, U, A, K, N, _)),
          () => {
            (v.current && ((0, s.unmountLinkForCurrentNavigation)(v.current), (v.current = null)),
              (0, s.unmountPrefetchableInstance)(e));
          }
        ),
        [N, U, A, K, _],
      ),
      z = {
        ref: (0, a.useMergedRef)(q, B),
        onClick(e) {
          (w || "function" != typeof E || E(e),
            w && r.props && "function" == typeof r.props.onClick && r.props.onClick(e),
            A &&
              (e.defaultPrevented ||
                (function (e, t, n, r, u, l, f) {
                  let { nodeName: a } = e.currentTarget;
                  if (
                    !(
                      ("A" === a.toUpperCase() &&
                        (function (e) {
                          let t = e.currentTarget.getAttribute("target");
                          return (
                            (t && "_self" !== t) ||
                            e.metaKey ||
                            e.ctrlKey ||
                            e.shiftKey ||
                            e.altKey ||
                            (e.nativeEvent && 2 === e.nativeEvent.which)
                          );
                        })(e)) ||
                      e.currentTarget.hasAttribute("download")
                    )
                  ) {
                    if (!(0, d.isLocalURL)(t)) {
                      u && (e.preventDefault(), location.replace(t));
                      return;
                    }
                    if ((e.preventDefault(), f)) {
                      let e = !1;
                      if (
                        (f({
                          preventDefault: () => {
                            e = !0;
                          },
                        }),
                        e)
                      )
                        return;
                    }
                    o.default.startTransition(() => {
                      (0, p.dispatchNavigateAction)(
                        n || t,
                        u ? "replace" : "push",
                        null == l || l,
                        r.current,
                      );
                    });
                  }
                })(e, U, F, v, k, m, x)));
        },
        onMouseEnter(e) {
          (w || "function" != typeof O || O(e),
            w && r.props && "function" == typeof r.props.onMouseEnter && r.props.onMouseEnter(e),
            A && N && (0, s.onNavigationIntent)(e.currentTarget, !0 === L));
        },
        onTouchStart: function (e) {
          (w || "function" != typeof S || S(e),
            w && r.props && "function" == typeof r.props.onTouchStart && r.props.onTouchStart(e),
            A && N && (0, s.onNavigationIntent)(e.currentTarget, !0 === L));
        },
      };
    return (
      (0, c.isAbsoluteUrl)(F)
        ? (z.href = F)
        : (w && !M && ("a" !== r.type || "href" in r.props)) || (z.href = (0, i.addBasePath)(F)),
      (l = w ? o.default.cloneElement(r, z) : (0, u.jsx)("a", { ...R, ...z, children: n })),
      (0, u.jsx)(g.Provider, { value: h, children: l })
    );
  }
  let g = (0, o.createContext)(s.IDLE_LINK_STATUS),
    _ = () => (0, o.useContext)(g);
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
